
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intents",
      function () {
        return require("private-next-pages/intents/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intents"])
      });
    }
  